import AgendaTipologieVisitaPage from "./pages/AgendaTipologieVisitaListPage.vue";
import AgendaSpecializzazioniListPage from "./pages/AgendaSpecializzazioniListPage.vue";
import AgendaTipologieListPage from "./pages/AgendaTipologieListPage.vue";
import AgendaStatiListPage from "./pages/AgendaStatiListPage.vue";
import AgendaAppuntamentiStatiListPage from "./pages/AgendaAppuntamentiStatiListPage.vue";
export default {
    AgendaTipologieVisitaPage, AgendaTipologieListPage, AgendaSpecializzazioniListPage, AgendaStatiListPage, AgendaAppuntamentiStatiListPage

};
